{
	"main": {
		"title": "Powered Flight Start List",
		"nezakljuceni": "UNFINISHED FLIGHTS",
		"zakljuceni": "FINISHED FLIGHTS"
	},
	"table": {
		"reg": "REG.",
		"datum": "DATE",
		"vzlet": "TAKEOFF",
		"pilot": "PILOT",
		"naloga": "TASK",
		"pristanek": "LANDING",
		"titleU": "List of ultralight flights"
	},
	"labels": {
		"datumOd": "Date FROM:",
		"datumDo": "Date TO:",
		"pilotJ": "Select glider pilot:",
		"instruktor": "Select glider instructor:",
		"registracijaJ": "Select glider registration:",
		"namenJ": "Select purpose:",
		"nalogaJ": "Select glider task:",
		"pilotM": "Select towplane pilot:",
		"registracijaM": "Select towplane registration:",
		"vzlet": "Select takeoff:",
		"pristanek": "Select landing:",
		"poletanje": "Takeoff:",
		"odklop": "Release:",
		"nezakljucen": "Unfinished flight?",
		"pristanekJ": "Glider landing:",
		"pristanekM": "Towplane landing:",
		"opomba": "Note",
		"niMozno": "This record cannot be edited here. Edit it in the glider flight section!"
	},
	"modal": {
		"registracija": "registration",
		"pilot": "pilot",
		"vlecno": "towplane:",
		"instruktor": "instructor:",
		"namen": "purpose:",
		"naloga": "task:",
		"vzlet": "takeoff location:",
		"pristanek": "landing location:",
		"casVzleta": "takeoff time:",
		"casOdklopa": "release time:",
		"casPristanka": "landing time:",
		"casLetenja": "flight time:",
		"stPristankov": "number of landings:",
		"ifr": "ifr:",
		"nocno": "night:",
		"vizuelno": "visual:",
		"opomba": "note:",
		"datumL": "flight date:",
		"datumV": "entry date:",
		"stanjeStevca": "engine odometer reading: "
	},
	"edit": {
		"titleJ": "GLIDER DATA",
		"reg": "Select aircraft registration:",
		"pilot": "Select pilot:",
		"instruktor": "Select instructor:",
		"namen": "Select purpose:",
		"naloga": "Select task:",
		"titleM": "TOWPLANE DATA",
		"pilotM": "towplane pilot:",
		"regM": "towplane registration",
		"titleS": "GENERAL DATA",
		"krajV": "Select takeoff:",
		"krajP": "Select landing:",
		"opomba": "Note:"
	},
	"modalNL": {
		"title": "Finish selected record",
		"reg": "registration:",
		"pilot": "pilot:",
		"instruktor": "instructor",
		"namen": "purpose:",
		"naloga": "task:",
		"casV": "takeoff time:",
		"krajV": "takeoff location:",
		"krajP": "landing location:",
		"pristanekM": "Powered aircraft landing:",
		"klubL": "Aircraft club:",
		"klubP": "Pilot club:",
		"casL": "flight time:",
		"opomba": "note:",
		"datumL": "flight date:",
		"datumV": "entry date:",
		"stanjeStevca": "engine odometer reading: ",
		"v_zraku": "Flight time (air): "
	},
	"buttons": {
		"zakljuciLet": "Finish flight",
		"brisiIzbiro": "Clear selection",
		"urediPodatke": "Edit data",
		"posodobiPodatke": "Update data",
		"izbrisiZapis": "Delete record",
		"csv": "Export to CSV",
		"natisni": "Print",
		"poslji": "Send"
	},
	"data": {
		"title": "Data",
	  	"stPristankov": "No. of landings:",
	  	"stLetov": "No. of flights:",
	  	"casVZraku": "Duration:"
	},
	"obvestila": {
		"zapisPrihodnost": "The entry has a date set in the future, CORRECT the selected date!",
		"zapisCasPrihodnost": "One or more entries have a time set in the future, check the times!",
		"zapisCasNapaka": "The entry times are incorrect! Check the times again!",
		"napakaPristanka": "Landing time cannot be before takeoff time!",
		"zapisPobrisan": "Entry successfully deleted",
		"napakaPrazenPristanek": "Input error, landing time cannot be empty",
		"posodobitevUspesna": "Update successful",
		"napakaPosodabljanja": "Error updating data.",
		"napakaBranja": "Error reading data.",
		"napakaIzbrisa": "Error deleting data.",
		"vprasanjeIzbris": "Are you sure you want to delete this entry?",
		"napakaVnosa": "Input error, please check if all fields are filled!",
		"letZakljucen": "Flight successfully completed.",
		"letNiZakljucen": "Error completing the flight."
	}
}